import { render, staticRenderFns } from "./ServeFinancialStatementOnOtherParty.vue?vue&type=template&id=0d1920de"
import script from "./ServeFinancialStatementOnOtherParty.vue?vue&type=script&lang=ts"
export * from "./ServeFinancialStatementOnOtherParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports